import { ofType } from "redux-observable";
import { merge } from "rxjs";
import { combineChecks } from "../../guards/combineChecks";
import { guard } from "../../guards/guard";
import { pathEmpty } from "../../guards/pathEmpty";
import { TypeActionProductionInfo } from "../../info/production/actionProductionInfo";
import { checkTutorialNextStepConfigExists } from "../checks/checkTutorialNextStepConfigExists";
import { checkTutorialProduceClickStartProduction } from "../checks/checkTutorialProduceClickStartProduction";
import { checkTutorialQuestClickStartProduction } from "../checks/checkTutorialQuestClickStartProduction";
import { checkTutorialSowClickStartProduction } from "../checks/checkTutorialSowClickStartProduction";
import { pathTutorialUpdate } from "../path/pathTutorialUpdate";
export var epicTutorialOnRecipeSelect = function (action$, state$, deps) {
    var actionProduceClickStartProduction$ = action$.pipe(ofType(TypeActionProductionInfo.RecipeSelect), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkTutorialNextStepConfigExists,
            checkTutorialProduceClickStartProduction,
        ])(pathTutorialUpdate),
    ]));
    var actionSowClickStartProduction$ = action$.pipe(ofType(TypeActionProductionInfo.RecipeSelect), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkTutorialNextStepConfigExists,
            checkTutorialSowClickStartProduction,
        ])(pathTutorialUpdate),
    ]));
    var actionQuestClickStartProduction$ = action$.pipe(ofType(TypeActionProductionInfo.RecipeSelect), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkTutorialNextStepConfigExists,
            checkTutorialQuestClickStartProduction,
        ])(pathTutorialUpdate),
    ]));
    return merge(actionSowClickStartProduction$, actionProduceClickStartProduction$, actionQuestClickStartProduction$);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/epics/epicTutorialOnRecipeSelect.ts
// module id = 2489
// module chunks = 3